package com.essntl.core.unsplash.data.response

import com.essntl.core.unsplash.domain.models.Picture
import kotlinx.serialization.Serializable

@Serializable
internal data class PictureDto(
    val id: String,
    val urls: Urls,
) {
    fun toModel() =
        Picture(
            id = id,
            url = urls.regular
                .split("?")
                .first(),
        )
}
